module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.147e3378.woff";